// Submodules
import { getArticleHeader, getManufacturerHeader, getDescription } from '../egr-gui-utils/CoreHelper';

import eaiws = egr.wcf.eaiws;
import bsk =  egr.wcf.bsk;

export class XLSXEntry<T extends bsk.ViewItem> {
    public articleInformation: string;
    public projectName: string;
    public manufacturer: string;
    public description: string;
    public quantity: number = 1;
    public singlePrice: number = 0;

    constructor(
        public item: T,
        articleProperties: eaiws.basket.ArticleProperties,
        public itemProperties: eaiws.basket.ItemProperties,
        calculation: eaiws.basket.CalculationSheetInfo | undefined
    ) {
        this.articleInformation = getArticleHeader(articleProperties);
        this.manufacturer = getManufacturerHeader(articleProperties);
        this.description = getDescription(articleProperties);
        this.quantity = articleProperties.quantity === undefined ? 1 : articleProperties.quantity;
        if (calculation !== undefined && calculation.unitNetPrice !== undefined && calculation.unitNetPrice.value !== undefined) {
            this.singlePrice = calculation.unitNetPrice.value;
        }
    }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/submodules/articlelist-export/XLSXEntry.ts